<div class="panel-options-body overflow-wrapper">
    <div>
        <ng-container *ngIf="!isEduForm">
            <ng-container *ngIf="!isPaymentForm; else showLabelOnly">
                <div class="form-group mb-10">
                    <label>
                        {{ "action_after_confirm" | translate }}
                    </label>
                    <select
                        class="form-control"
                        [class.disabled]="addChatBotToForm"
                        [formControl]="actionAfterConfirmType"
                    >
                        <option [ngValue]="EActionAfterConfirm.message">
                            {{ "show_message_option" | translate }}
                        </option>
                        <option [ngValue]="EActionAfterConfirm.link">
                            {{ "go_to_page_option" | translate }}
                        </option>
                    </select>
                </div>
            </ng-container>

            <ng-template #showLabelOnly>
                <div class="form-group mb-0">
                    <label>
                        {{ "action_after_payment_confirm" | translate }}
                    </label>
                </div>
            </ng-template>

            <sp-control-handle
                *ngIf="actionAfterConfirmType.value === EActionAfterConfirm.message"
                [class.disabled]="addChatBotToForm"
                [controlHandleMainText]="subscriptionMessage.value | spHtmlToText"
                (editActionEvent)="showSubscriptionMessageModal()"
            ></sp-control-handle>

            <div class="form-group" *ngIf="addChatBotToForm">
                <p
                    class="help-block small mb-0"
                    [innerHtml]="'chat_bot_noty' | translate: { limit: captchaLimit.value }"
                ></p>
            </div>

            <div
                *ngIf="actionAfterConfirmType.value === EActionAfterConfirm.link && !addChatBotToForm"
                class="form-group"
            >
                <input
                    *ngIf="!isPaymentForm || (isPaymentForm && isHasSuccessPageOption)"
                    type="text"
                    class="form-control"
                    placeholder="https://example.com"
                    [formControl]="openLink"
                />
                <input
                    *ngIf="isPaymentForm && !isHasSuccessPageOption"
                    type="text"
                    class="form-control disabled"
                    placeholder="https://example.com"
                    value=""
                />
                <div
                    *ngIf="pages?.length"
                    class="page-dropdown"
                    dropdown
                    container="body"
                    [ngClass]="{ disabled: isPaymentForm && !isHasSuccessPageOption }"
                >
                    <a class="dotted" dropdownToggle
                        >{{ "control_choose_page" | translate }} <span class="caret"></span
                    ></a>
                    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                        <li *ngFor="let page of pages">
                            <a class="dropdown-item" (click)="setOpenLink(page)">{{ page.name }}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="form-group form-horizontal row" *ngIf="!isPaymentForm && !isShopCart">
                <label class="col-xs-9 control-label">
                    {{ "crm_update_data" | translate }}
                    <span
                        class="small sp-icon icon-question color-light hover-effect"
                        [tooltip]="'crm_update_data_hint' | translate"
                        [placement]="'top'"
                        [adaptivePosition]="true"
                        triggers="mouseover:mouseleave"
                    ></span>
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [active]="updateExistingContact.value"
                        (toggleActiveEvent)="setUpdateData($event)"
                    ></sp-switch>
                </div>
            </div>

            <div class="form-group form-horizontal mb-10 row" *ngIf="!isPaymentForm && !isShopCart">
                <label class="col-xs-9 control-label">
                    {{ "form_settings_corporate_email" | translate }}
                    <span
                        class="small sp-icon icon-question color-light hover-effect"
                        [tooltip]="'form_settings_corporate_email_tooltip' | translate"
                        [placement]="'top'"
                        [adaptivePosition]="true"
                        triggers="mouseover:mouseleave"
                    ></span>
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [active]="isEnableCorporateEmail.value"
                        (toggleActiveEvent)="handleIsEnabledCorporateEmail($event)"
                    ></sp-switch>
                </div>
            </div>

            <div class="form-group form-horizontal mb-10 row" *ngIf="!isPaymentForm && !isShopCart">
                <label class="col-xs-9 control-label">
                    {{ "form_settings_captcha" | translate }}
                    <span
                        class="small sp-icon icon-question color-light hover-effect"
                        [tooltip]="'form_settings_captcha_tooltip' | translate"
                        [placement]="'top'"
                        [adaptivePosition]="true"
                        triggers="mouseover:mouseleave"
                    ></span>
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [active]="isEnabledCaptcha.value"
                        (toggleActiveEvent)="handleIsEnabledCaptcha($event)"
                    ></sp-switch>
                </div>
            </div>
        </ng-container>

        <div class="form-group" *ngIf="isEnabledCaptcha.value">
            <select class="form-control" [formControl]="captchaLimit">
                <option [ngValue]="ECaptchaLimits.ten" [selected]="captchaLimit.value === ECaptchaLimits.ten">
                    {{ "form_settings_captcha_option" | translate: { limit: ECaptchaLimits.ten } }}
                </option>
                <option [ngValue]="ECaptchaLimits.hundred" [selected]="captchaLimit.value === ECaptchaLimits.hundred">
                    {{ "form_settings_captcha_option" | translate: { limit: ECaptchaLimits.hundred } }}
                </option>
                <option [ngValue]="ECaptchaLimits.thousand" [selected]="captchaLimit.value === ECaptchaLimits.thousand">
                    {{ "form_settings_captcha_option" | translate: { limit: ECaptchaLimits.thousand } }}
                </option>
            </select>

            <p
                class="help-block small mb-0"
                [innerHtml]="'form_settings_captcha_noty' | translate: { limit: captchaLimit.value }"
            ></p>
        </div>

        <div *ngIf="isPaymentForm && !isHasSuccessPageOption" class="alert alert-warning">
            {{ "alert_not_available_choose_page" | translate }}
        </div>

        <ng-container *ngIf="isPaymentForm || isShopCart">
            <div class="form-group form-horizontal row">
                <label class="col-xs-9 control-label">
                    {{ "control_add_promocode_field" | translate }}
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch
                        [active]="isEnabledPromoCode.value"
                        (toggleActiveEvent)="setEnabledPromoCode($event)"
                    ></sp-switch>
                </div>
            </div>

            <div class="well" *ngIf="isEnabledPromoCode.value">
                <div class="form-group">
                    <label class="control-label">
                        {{ "control_promocode_label" | translate }}
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        [placeholder]="'control_promocode_label_placeholder' | translate"
                        [formControl]="labelPromoCode"
                    />
                </div>

                <div class="form-group">
                    <label class="control-label">
                        {{ "control_promocode_placeholder" | translate }}
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        [placeholder]="'control_promocode_placeholder_placeholder' | translate"
                        [formControl]="placeholderPromoCode"
                    />
                </div>

                <div class="form-group">
                    <label class="control-label">
                        {{ "control_promocode_select_label" | translate }}
                    </label>
                    <!--
                        Options come through [items], like every other ng-select in the
                        app — see the signal twin for why projected <ng-option> children
                        left the list empty once the codes arrived asynchronously.
                    -->
                    <ng-select
                        [appendTo]="'body'"
                        class="formControl sp-ng-select"
                        [items]="promoCodes"
                        bindValue="id"
                        bindLabel="promoCode"
                        [placeholder]="'control_promocode_choose_promocode' | translate"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [ngModel]="selectedPromoCode.value"
                        (ngModelChange)="setPromoCode($event)"
                    >
                        <ng-template ng-option-tmp let-item="item">
                            {{ item.promoCode }}
                            <span class="small text-muted">{{ promoCodeDiscountLabel(item) }}</span>
                        </ng-template>
                    </ng-select>
                    <div class="help-block small text-muted">
                        {{ selectedPromoValues }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
